import http from 'axios'
import { authApiURL as API_URL } from '../../utils'

const getDeparturePoints = ({
  packageType = 'package',
  transport = 'flight',
  currency = 'EUR'
}) => {
  const action = 'getCacheDepartures'
  const params = {
    action: action,
    package_type: packageType,
    transport: transport,
    currency: currency
  }
  return http.get(API_URL, { params: params })
    .then(function (res) {
      return res.data
    })
}

const getDestinations = ({
  packageType = 'package',
  transport = 'flight',
  departure,
  currency = 'EUR'
}) => {
  const action = 'getCacheDestinations'
  const params = {
    action: action,
    type: packageType,
    transport: transport,
    departure: departure,
    currency: currency
  }
  return http.get(API_URL, { params: params })
    .then(function (res) {
      return res.data
    })
}

const getResorts = ({
  packageType = 'package',
  transport = 'flight',
  departure,
  country,
  currency = 'EUR'
}) => {
  const params = {
    action: 'getCacheResorts',
    type: packageType,
    transport: transport,
    departure: departure,
    country: country,
    currency: currency
  }
  return http.get(API_URL, { params: params })
    .then(function (res) {
      return res.data
    })
}

const getTours = ({
  packageType = 'package',
  transport = 'flight',
  departure,
  destination,
  month,
  currency = 'EUR'
}) => {
  const params = {
    action: 'getCacheTours',
    type: packageType,
    transport: transport,
    departure: departure,
    destination: destination,
    month: '' + month,
    currency: currency
  }
  return http.get(API_URL, { params: params })
    .then(function (res) {
      return res.data
    })
}

const search = ({
  packageType = 'package',
  transport = 'flight',
  departure,
  destination,
  month,
  currency,
  pack
}) => {
  const params = {
    action: 'searchCache',
    type: packageType,
    transport,
    departure,
    destination,
    month: '' + month,
    currency,
    pack
  }
  return http.get(API_URL, { params: params })
    .then(res => { return res.data })
}

export {
  getDeparturePoints,
  getDestinations,
  getResorts,
  getTours,
  search
}
